import { modal } from "../pages/constants";
import ButtonSecondary from "../components/ButtonSecondary";

export default function Modal({ url, modalOpen, setModalOpen }){

    const closeFromBG = (e) => {
        if(e.target == e.currentTarget){
            setModalOpen(false);
        }
    };

    const handleKeypress = (e) => {
        const key = e.key;

        if (key == "Esc" || key == "Escape") {
            setModalOpen(false);
        }

        // Focus trap to prevent focus from leaving the modal while it's open
        if (key == "Tab") {
            const hasShift = e.shiftKey; // boolean
            const currFocus = document.activeElement;
            const close = document.querySelector(".js-modal-close");
            const button = document.querySelector(".js-modal-button");
            const trigger = document.querySelector(".js-modal-trigger");

            if (currFocus == close && hasShift) {
                setModalOpen(false);
            }
            else if (currFocus == button && !hasShift) {
                setModalOpen(false);
                setTimeout(() => trigger.focus(), 100);
            }
        }
    };

    return (
        <div className={`modal ${modalOpen ? "open" : ""}`} role="dialog" aria-labelledby="modal-heading" aria-modal="true" onClick={closeFromBG}>
            <div className="modal__content" onKeyDown={handleKeypress}>
                <div className="modal__content-inner">
                    <button className="js-modal-close modal__close" type="button" onClick={() => setModalOpen(false)}>
                        <span className="modal__close-text">Close</span>
                    </button>
                    <h3 id="modal-heading" className="modal__heading fz40 fz32@md">{modal.heading}</h3>
                    <p className="modal__body fz16 fz14@md">{modal.body}</p>
                    <ButtonSecondary className="js-modal-button modal__button" href={url}>{modal.buttonLabel}</ButtonSecondary>
                </div>
            </div>
        </div>
    );
}
